import React, { useState, useEffect } from 'react';
import PageBackgroundBeam from './PageBackgroundBeam';
import logo from '../assets/logo-publisearch.png';
import './PasswordGate.css';

const PASSWORD_HASH = '24c7260701f95784e616cf18f8ef401c83623c55c6779de413d8016d42207666';

async function hashPassword(password) {
  const encoded = new TextEncoder().encode(password);
  const buffer = await crypto.subtle.digest('SHA-256', encoded);
  const bytes = Array.from(new Uint8Array(buffer));
  return bytes.map(b => b.toString(16).padStart(2, '0')).join('');
}

function PasswordGate({ children }) {
  const [authenticated, setAuthenticated] = useState(
    () => sessionStorage.getItem('authenticated') === 'true'
  );
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (authenticated) {
      sessionStorage.setItem('authenticated', 'true');
    }
  }, [authenticated]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    const hash = await hashPassword(password);

    if (hash === PASSWORD_HASH) {
      setAuthenticated(true);
    } else {
      setError('Contraseña incorrecta');
      setPassword('');
    }

    setLoading(false);
  };

  if (authenticated) {
    return <>{children}</>;
  }

  return (
    <PageBackgroundBeam>
      <div className="password-gate">
        <div className="password-gate-content">
          <div className="password-gate-logo">
            <img src={logo} alt="Publisearch" className="logo" />
          </div>

          <h2 className="password-gate-title">Acceso Restringido</h2>

          <form className="password-gate-form" onSubmit={handleSubmit}>
            <input
              type="password"
              className="password-gate-input"
              placeholder="Ingrese contraseña"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoFocus
              disabled={loading}
            />
            <button type="submit" className="btn-start" disabled={loading}>
              {loading ? 'Verificando...' : 'Ingresar'}
              {!loading && <span className="btn-arrow">&#8594;</span>}
            </button>
          </form>

          {error && <p className="password-gate-error">{error}</p>}
        </div>
      </div>
    </PageBackgroundBeam>
  );
}

export default PasswordGate;
